// extracted by mini-css-extract-plugin
export default {"outerDiv":"UserFollowersCard_outerDiv__Wvj+D","innerDiv":"UserFollowersCard_innerDiv__cWwLs","btns":"UserFollowersCard_btns__l0gpT"};